import { FC } from 'react';
import styles from './PageHeader.module.scss';
import CloseBtnCross from '../CloseBtnCross/CloseBtnCross';

const PageHeader: FC<{ title: string; closeBtn?: () => void }> = ({ title, closeBtn }) => {
    return (
        <header className={styles.pageHeader}>
            <div style={{ width: '28px', height: '28px' }}></div>
            <h1>{title}</h1>
            {closeBtn && <CloseBtnCross onClick={closeBtn} />}
            {!closeBtn && <div style={{ width: '28px', height: '28px' }}></div>}
        </header>
    );
};

export default PageHeader;
